// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Projets_wrapper__PRTID","title":"Projets_title__2LfeG","clients":"Projets_clients__1sLkT"};